import SketchOrderCardLocation from "./SketchOrderCardLocation";

export default SketchOrderCardLocation;
